import React from 'react';


const Todos=({todos, deleteTodo})=>{
    const todoList=todos.length?(
        todos.map(todo=>{
            return(
                <div className="collection-item" key={todo.id}>
                    <span onClick={
                        ()=>{
                            deleteTodo(todo.id)
                        }
                    }>{todo.item}</span>
                </div>
            )
        })
    ):(
        <p className="center">All Tasks Completed !!!</p>
    );
    return(
        <div className="todos collection">
            {todoList}


        </div>
    )
}

export default Todos;